import yup from 'src/infra/Yup';
import {PlatformIntl} from 'src/infra/PlatformIntl';

const intl = PlatformIntl.getInstance();

export const createIntegrationSchema = yup.object().shape({
    title: yup.string().label(intl.formatMessage('sharedName')).required(),
    description: yup.string().label(intl.formatMessage('sharedDescription')).required(),
    url: yup.string().url(intl.formatMessage('sharedUrlInvalid')).label('URL').required(),
});

export const updateIntegrationSchema = createIntegrationSchema.clone().shape({
    id: yup.number().required(),
});
